export const rol = [
  {
    label: "Id",
    name: "idrol",
    type: "INTEGER",
    readonly: true,
    showOnList: true,
  },
  {
    label: "Nombre",
    name: "nombre",
    type: "STRING",
    showOnList: true,
    showAsLabel: true,
  },
  {
    label: "Descripción",
    name: "descripcion",
    type: "STRING",
    allowNull: true,
    showOnList: true,
  },
];
